import { render, staticRenderFns } from "./BlockUpcomingProjects.vue?vue&type=template&id=d67bb3c4"
import script from "./BlockUpcomingProjects.vue?vue&type=script&lang=js"
export * from "./BlockUpcomingProjects.vue?vue&type=script&lang=js"
import style0 from "./BlockUpcomingProjects.vue?vue&type=style&index=0&id=d67bb3c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports